import type { FaireProductEntity } from "../../entity_types/product";

export const p_esqeu42cj5: FaireProductEntity = {
  token: "p_esqeu42cj5",
  type: "product",
  name: "Veggie Baby Bonnet Hat - 2 Colors (Organic Muslin)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/0cae20ef3b76148795db77a09d967f487bac598ef3b08a56bd6501d76bb3e255.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/93f1dc8db0e90b4301676d72e899599641ea640ad323564b028237ed31d719a3.jpeg",
    "https://cdn.faire.com/fastly/732b5405f99a37c3081e8cfed80230276e7b8575f3b68a344ca981ca102071df.jpeg",
  ],
  priceDollars: 10,
  description:
    "• Soft, lightweight, breathable, cozy, and comfy.\n• Lined.\n• Digitally printed for extra softness.\n• Chemical free & non-toxic formulation, eco-friendly & sustainable.\n• Machine wash and dry, durable and long lasting.\n• Ethically produced in India from small farmer sourced cotton.\n• 100% Organic cotton muslin with organic cotton voile lining.",
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-11T05:03:42.639Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
